import React, { createContext, PropsWithChildren, useContext } from 'react';

import { useQuery } from '@apollo/client';

import { QUERY_DISCO_DEVICE_CONFIGS } from 'client/app/apps/disco-prototype/api/queries/discoDeviceConfigs';

export type DeviceOption = {
  value: string;
  label: string;
};

type DeviceConfigContextType = {
  deviceOptions: DeviceOption[];
};

export const DeviceConfigContext = createContext<DeviceConfigContextType | undefined>(
  undefined,
);

export const useDeviceConfigContext = () => {
  const context = useContext(DeviceConfigContext);
  if (context === undefined) {
    throw new Error('useDeviceConfigContext must be used within a DeviceConfigProvider');
  }
  return context;
};

export function DeviceConfigProvider({ children }: PropsWithChildren) {
  const { data, loading } = useQuery(QUERY_DISCO_DEVICE_CONFIGS);

  if (loading || !data) return null;

  const devices = data.discoDeviceConfigs;

  const deviceOptions = devices.map(device => ({
    label: device.description,
    value: device.id,
  }));

  const value = {
    deviceOptions,
  };

  return (
    <DeviceConfigContext.Provider value={value}>{children}</DeviceConfigContext.Provider>
  );
}
